import * as React from 'react';
import * as I18n from 'i18n-js';
import * as texture from '../../../../images/homepage/section-texture.jpg';

import { withUserContext, IUserContext } from '@reverbdotcom/commons/dist/components/user_context_provider';

export class HomepageValueProps extends React.Component<IUserContext, {}> {
  getI18nRegion() {
    if (this.props.user.shippingRegionCode === 'UK') return 'uk';
    return 'default';
  }

  renderSection(num) {
    return (
      <div>
        <h3>
          {I18n.t(`discovery.homepageValueProps.${this.getI18nRegion()}.section${num}.title`)}
        </h3>
        <p>
          {I18n.t(`discovery.homepageValueProps.${this.getI18nRegion()}.section${num}.body`)}
        </p>
      </div>
    );
  }

  render() {
    return (
      <section
        className="homepage-value-props"
        style={{ backgroundImage: `url("${texture}")` }}
      >
        <div className="homepage-value-props__inner">
          {this.renderSection(1)}
          {this.renderSection(2)}
          {this.renderSection(3)}
          {this.renderSection(4)}
        </div>
      </section>
    );
  }
}

export default withUserContext(HomepageValueProps);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/homepage/homepage_value_props.tsx